import dynamic from 'next/dynamic'
import classNames from 'classnames'
import type { ComponentType, Attributes } from 'react'
import { type DismissibleProps } from '../components/tag-dismissible'
import { type ChoiceProps } from '../components/tag-choice'
import { type FilterProps } from '../components/tag-filter'
import { type SearchProps } from '../components/tag-search/tag-search'

import './list.scss'

type TagType = {
  dismissible: DismissibleProps & Attributes;
  choice: ChoiceProps & Attributes;
  filter: FilterProps & Attributes;
  search: SearchProps & Attributes;
};

const TagVarations = {
  'dismissible': dynamic(() => import('../components/tag-dismissible')),
  'choice': dynamic(() => import('../components/tag-choice')),
  'filter': dynamic(() => import('../components/tag-filter')),
  'search': dynamic(() => import('../components/tag-search/tag-search')),
} as const

type Props<V extends keyof TagType> = {
  variant: V
  list: TagType[V][]
  className?: string
  title?: string
}

export const TagsList = <V extends keyof TagType>(props: Props<V>) => {
  const { variant, list, className, title } = props
  const Tag = TagVarations[variant] as ComponentType<TagType[V]>

  return (
    <div className={classNames('row u-px-8', className)}>
      {title && <span className='h4 u-mb-8 u-fs-14'>{title}</span>}
      <div className='tag-list-scroll-container'>
        {list.map((tagProps, index) =>
          <Tag key={index} className='u-mr-16' {...tagProps} />
        )}
      </div>
    </div>
  )
}

export default TagsList
